import Vue from 'vue'
import firebase from 'firebase/app';
import 'firebase/auth';
import App from './App.vue';
import JsonExcel from "vue-json-excel";
import router from './router'

let app = null;

Vue.component("downloadExcel", JsonExcel);
Vue.config.productionTip = false;


firebase.auth().onAuthStateChanged(() => {
    if (!app) {
        app = new Vue({
            router,
            render: h => h(App)
        }).$mount('#app')

    }
});

